<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useIdleSession } from '@/composables/useIdleSession'

useIdleSession()
</script>

<template>
  <RouterView />
</template>
